import Immutable from 'immutable';
import { SEARCH_UPDATE_COURSES } from '../../Searches/actions';

const DEFAULT_STATE = Immutable.fromJS({
  byPath: {},
});

export function CourseTiles(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case SEARCH_UPDATE_COURSES: {
      const { courses } = action;
      const coursesByPath = Immutable.fromJS(courses).reduce(
        (current, course) => {
          return current.set(course.get('path'), course);
        },
        Immutable.Map()
      );

      return state.mergeIn(['byPath'], coursesByPath);
    }
    default: {
      return state;
    }
  }
}
